"use client";

import Reveal from "@/app/components/Reveal";

type ScrollStyle = {
  opacity: number;
  scale: number;
  filter: string;
};

type Props = {
  scrollStyle?: ScrollStyle;
};

function LogoMark() {
  return (
    <div className="float-y relative flex h-[220px] w-[220px] items-center justify-center md:h-[300px] md:w-[300px]">
      <div className="absolute inset-0 rounded-full bg-[#202e64]" />
      <div className="absolute inset-0 rounded-full border border-white/10 bg-white/4 backdrop-blur-xl" />
      <div className="absolute inset-6 rounded-full border border-white/5" />
      <div className="relative z-10 flex flex-col items-center gap-2 text-center">
        <span className="text-[10px] uppercase tracking-[0.3em] text-white/60">
          IT Company
        </span>
      </div>
    </div>
  );
}

export default function CenterImage({ scrollStyle }: Props) {
  if (scrollStyle) {
    return (
      <div
        style={{
          opacity: scrollStyle.opacity,
          transform: `scale(${scrollStyle.scale})`,
          filter: scrollStyle.filter,
        }}
        className="relative flex items-center justify-center"
      >
        <LogoMark />
      </div>
    );
  }

  return (
    <Reveal
      scale={0.6}
      blur={30}
      duration={0.8}
      className="relative flex items-center justify-center"
    >
      <LogoMark />
    </Reveal>
  );
}
